<template>
  <Card v-if="organization" :title="organization.name">
    <form class="form" novalidate>
      <FormRow :withThreeColumns="true">
        <FormReadonlyField v-model="organizationType" :label="t('organization.type')" name="type"/>
        <FormReadonlyField v-model="organization.chapter" :label="t('organization.chapter')"
                           name="chapter"/>
        <FormReadonlyField v-model="organization.enterpriseNumber"
                           :label="t('organization.enterpriseNumber')"
                           name="enterpriseNumber"/>
      </FormRow>
      <FormRow :withThreeColumns="true">
        <FormReadonlyField v-model="organization.apartment" :label="t('global.apartment')"
                           name="apartment"/>
        <FormReadonlyField v-model="organization.street" :label="t('global.street')" name="street"/>
        <FormReadonlyField v-model="organization.city" :label="t('global.city')" name="city"/>
      </FormRow>
      <FormRow :withThreeColumns="true">
        <FormReadonlyField v-model="organization.zipCode" :label="t('global.zipCode')" name="zipCode"/>
        <div class="form__duo-fields">
          <FormReadonlyField v-model="organization.phoneNumber" :label="t('global.phoneNumber')"
                             name="phoneNumber"/>
          <FormReadonlyField v-model="organization.phoneExtension" :label="t('global.phoneExtension')"
                             name="phoneExtension"/>
        </div>
        <FormReadonlyField v-model="organization.email" :label="t('global.email')" name="email"/>
      </FormRow>
      <FormRow :withThreeColumns="true">
        <FormReadonlyField v-model="organization.subscription.startAt"
                           :label="t('organization.subscriptionStartAt')"
                           name="subscriptionStartAt"/>
        <FormReadonlyField v-model="organization.subscription.endAt"
                           :label="t('organization.subscriptionEndAt')"
                           name="subscriptionEndAt"/>
        <FormReadonlyField v-model="organization.memberNumber" :label="t('organization.memberNumber')"
                           name="memberNumber"/>
      </FormRow>
      <FormRow :withThreeColumns="true">
        <FormReadonlyField v-if="organization.type !== OrganizationType.Corporate"
                           v-model="organization.numberOfUnits" :label="t('organization.numberOfUnits')"
                           name="numberOfUnits"/>
        <FormReadonlyField
            v-if="organization.type === OrganizationType.RegularIndividual && organization.syndicate?.name"
            v-model="organization.syndicate.name"
            :label="t('organization.syndicate')"
            name="syndicateName"/>
      </FormRow>
    </form>
  </Card>
</template>
<script lang="ts" setup>
import {computed, onMounted, ref} from "vue"
import {useI18n} from "vue3-i18n"
import {useOrganizationService} from "@/inversify.config"
import {OrganizationType} from "@/types"
import {IFullOrganization} from "@/types/entities/organization";
import FormReadonlyField from "@/components/forms/FormReadonlyField.vue"
import Card from "@/components/layout/Card.vue"
import FormRow from "@/components/forms/FormRow.vue"
import {getFileFromUrl} from "@/helpers";

const {t} = useI18n()
const organizationService = useOrganizationService()

const organizationLogo = ref<File>()
const organization = ref<IFullOrganization>()
const organizationIsLoading = ref(false)

onMounted(async () => {
  await loadOrganization()
})

let organizationType = computed(() => {
  if (!organization.value)
    return
  let type = organization.value.type.makeFirstLetterLowercase()
  return t(`organization.types.${type}`)
})

async function loadOrganization() {
  organizationIsLoading.value = true
  let fullOrganization = await organizationService.getMySyndicate();
  if (fullOrganization) {
    organization.value = fullOrganization
    if (fullOrganization.logo)
      organizationLogo.value = await getFileFromUrl(fullOrganization.logo, fullOrganization.logo)
  }
  organizationIsLoading.value = false
}
</script>